import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { adminSearchUsers } from '../../utils/api';
import {
  AdminUserCountBreakdown, deleteUser, setAsTestUser, getAdminLatestUsers, getUsersByCompanySizeTable, getLatestBuyers, getLatestDemos,
  getLatestBuyersByMonth
} from '../../utils/api/admin';
import { refresh } from '../../services/auth.service';
import Spinner from '../../components/layout/Spinner';
import FadeIn from '../../utils/fadein';
import { FaCheckCircle, FaEllipsisV, FaEnvelope, FaGlobe, FaLinkedin, FaMap, FaRegEnvelope, FaRegMap, FaTimes, FaTimesCircle } from 'react-icons/fa';
import DemosPending from './DemosPending';
import { FaEyeDropper, FaRegCheckCircle } from 'react-icons/fa';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';

import './Buyers.css';

function Buyers() {
  const [loaded, setLoaded] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [latestBuyers, setLatestBuyers] = useState([]);
  const [users, setUsers] = useState([]);
  const [query, setQuery] = useState('');
  const [buyerCount, setBuyerCount] = useState(0);
  const [breakdown, setBreakdown] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showSetTestConfirm, setShowSetTestConfirm] = useState(false);
  const [sizeBreakdown, setSizeBreakdown] = useState([]);
  const [countApplications, setCountApplications] = useState(0);
  const [countApproved, setCountApproved] = useState(0);
  const [countDeclined, setCountDeclined] = useState(0);
  const [countTotalApplications, setCountTotalApplications] = useState(0);
  const [countTotalApproved, setCountTotalApproved] = useState(0);
  const [buyersWithDemos, setBuyersWithDemos] = useState(0);
  const [latestDemos, setLatestDemos] = useState([]);
  const [showDemos, setShowDemos] = useState(false);
  const [totalActive, setTotalActive] = useState(0);
  const [pieData, setPieData] = useState([]);
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  const baseImageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const screenshotUrl = process.env.REACT_APP_BASE_IMAGE_URL + 'companyscreenshots/';

  const tempData = [
    { name: 'Organic', value: 400 },
    { name: 'Referral', value: 300 },
    { name: 'Social Media', value: 300 },
    { name: 'Unknown', value: 200 },
  ];

  const COLORS = ['#818CF8', '#F472B6', '#34D399', '#FBBF24'];

  useEffect(() => {
    async function loadLatest() {
      let res = await getLatestBuyers();

      if (res.success) {
        setLatestBuyers(res.data);
      }
    }

    async function loadData() {
      let _date = new Date();
      _date.setDate(1);

      let res = await getLatestBuyersByMonth(_date.toDateString());

      if (res.success) {
        setUsers(res.data);
        setLoaded(true);

        let count_applications = 0;
        let count_approved = 0;
        let count_declined = 0;
        let count_active = 0;

        for (let i = 0; i < res.data.length; i++) {
          count_applications += parseInt(res.data[i].application_count);
          count_approved += parseInt(res.data[i].approved_count);
          count_declined += parseInt(res.data[i].declined_count);

          if (parseInt(res.data[i].application_count) > 0) {
            count_active++;
          }
        }

        setCountApplications(count_applications);
        setCountApproved(count_approved);
        setCountDeclined(count_declined);
        setTotalActive(count_active);

        

        // setCountTotalApplications(res.data[0].total_application_count);
        // setCountTotalApproved(res.data[0].total_approved_count);
      }
    }

    async function loadDemos() {
      let res = await getLatestDemos();

      if (res.success) {
        setLatestDemos(res.data);
      }
    }

    async function loadSizeBreakdown() {
      let res = await getUsersByCompanySizeTable();

      if (res.success) {
        setSizeBreakdown(res.data);
      }
    }

    async function loadDataBreakdown() {
      let res = await AdminUserCountBreakdown();

      if (res.success) {
        setBreakdown(res.data[0]);
        // setLoaded(true);
      }

      else if (res.status === 403) {
        await refresh();

        let res = await AdminUserCountBreakdown();

        if (res.success) {
          setBreakdown(res.data[0]);
          //  setLoaded(true);
        }
      }
    }

    loadData();
    loadLatest();
    loadDataBreakdown();
    loadSizeBreakdown();
    loadDemos();
  }, []);

  async function loadData(val) {
    let res = await getLatestBuyersByMonth(val);

    if (res.success) {
      setUsers(res.data);
      setLoaded(true);

      let count_applications = 0;
      let count_approved = 0;
      let count_declined = 0;
      let count_active = 0;

      const signupSourceCounts = res.data.reduce((acc, user) => {
        const source = user.signup_source || 'Unknown';
        acc[source] = (acc[source] || 0) + 1;
        return acc;
      }, {});

      const pieChartData = Object.keys(signupSourceCounts).map((source, index) => ({
        name: source,
        value: signupSourceCounts[source],
        color: [
          '#818CF8', // Indigo
          '#F472B6', // Pink
          '#34D399', // Green
          '#FBBF24', // Yellow
          '#60A5FA', // Blue
          '#A78BFA', // Purple
          '#E879F9', // Magenta
          '#F87171', // Red
          '#10B981', // Emerald
        ][index % 9]
      }));

      setPieData(pieChartData);

      for (let i = 0; i < res.data.length; i++) {
        count_applications += parseInt(res.data[i].application_count);
        count_approved += parseInt(res.data[i].approved_count);
        count_declined += parseInt(res.data[i].declined_count);

        if (parseInt(res.data[i].application_count) > 0) {
          count_active++;
        }
      }

      setCountApplications(count_applications);
      setCountApproved(count_approved);
      setCountDeclined(count_declined);
      setTotalActive(count_active);
    }
  }

  async function handleSearch() {
    if (query.length === 0) {
      loadData();
      return;
    }

    let id = null;

    if (Number.isInteger(parseInt(query)))
      id = parseInt(query);

    let res = await adminSearchUsers(query, id);

    if (res.success) {
      setUsers(res.data);
      setLoaded(true);
    }

    else if (res.status === 403) {
      await refresh();

      let res = await adminSearchUsers(query, id);

      if (res.success) {
        setUsers(res.data);
        setLoaded(true);
      }
    }
  }

  async function handleKeyUp(k) {
    if (k.key === 'Enter') {
      await handleSearch();
    }
  }

  async function handleConfirmDelete() {
    let res = await deleteUser(selectedUserId);

    if (res.success) {
      setShowDeleteConfirm(false);
      setShowSubMenu(false);
      await loadData();
    }
  }

  async function handleSetTest() {
    let res = await setAsTestUser(selectedUserId);

    if (res.success) {
      setShowSetTestConfirm(false);
      setSelectedUserId(null);
      setShowSubMenu(false);
      await loadData();
    }
  }

  async function handleMonthChange(val) {
    setLoaded(false);
    loadData(val);
  }

  function exportCSV() {
    const headers = ['First Name', 'Email'];
    const rows = latestBuyers.map(buyer => [buyer.first_name, buyer.email]);

    let csvContent = 'data:text/csv;charset=utf-8,';
    csvContent += headers.join(',') + '\n';
    rows.forEach(row => {
      csvContent += row.join(',') + '\n';
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'latest_buyers.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <>
      <Helmet>
        <title>Admin - Users</title>
      </Helmet>

      <div>
        <h1>Buyers {`(${parseInt(users.length)})`}</h1>

        {breakdown !== null && (
          <>
            <div style={{ display: 'flex', margin: '10px 0px' }}>
              <span className='admindashboard__role-tag--buyer'>
                Buyers: {breakdown.buyer_count}
              </span>

              <span className='admindashboard__role-tag--seller'>
                Sellers: {breakdown.seller_count}
              </span>

              <span className='admindashboard__role-tag--host'>
                Event Hosts: {breakdown.event_host_count}
              </span>

              <span className='admindashboard__role-tag--attendee'>
                Event Attendees: {breakdown.attendee_count}
              </span>

              <span className='admindashboard__red-flag'>
                Buyers - not verified: {breakdown.buyer_count_not_verified}
              </span>
            </div>
          </>
        )}
      </div>

      {/* <div>
        <h2>Company size breakdown</h2>

        <table className='table admindashboard__table'>
          {sizeBreakdown.map(item => (
            <tr>
              <td>{item.value}</td>
              <td>{item.count}</td>
            </tr>
          ))}
        </table>
      </div> */}

      <div>
        <button className='btn ml-10' onClick={() => exportCSV()}>Export CSV</button>
      </div>

      {/* Add Pie Chart */}
      <div className="bg-white p-6 rounded-lg shadow-sm mb-8">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Sign Up Sources</h3>
        <PieChart width={400} height={400}>
          <Pie
            data={pieData}
            cx="50%"
            cy="50%"
            innerRadius={80}
            outerRadius={120}
            fill="#8884d8"
            dataKey="value"
            label
          >
            {tempData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </div>

      <div className='buyers__date-header'>
        <select className='input select' onChange={(e) => handleMonthChange(e.target.value)}>
          <option value=''>Select month</option>
          <option value='7/1/2025'>July 2025</option>

          <option value='6/1/2025'>June 2025</option>

          <option value='5/1/2025'>May 2025</option>

          <option value='4/1/2025'>April 2025</option>
          <option value='3/1/2025'>March 2025</option>
          <option value='2/1/2025'>February 2025</option>
          <option value='1/1/2025'>January 2025</option>
          <option value='12/1/2024'>December 2024</option>
          <option value='11/1/2024'>November 2024</option>
          <option value='10/1/2024'>October 2024</option>
          <option value='9/1/2024'>September 2024</option>
          <option value='8/1/2024'>August 2024</option>
          <option value='7/1/2024'>July 2024</option>
          <option value='6/1/2024'>June 2024</option>
          <option value='5/1/2024'>May 2024</option>
          <option value='4/1/2024'>April 2024</option>
          <option value='3/1/2024'>March 2024</option>

        </select>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 p-4">
        {/* Total Users Card */}
        <div className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-gray-500 text-sm font-medium">Total Users</h3>
            <div className="p-2 bg-indigo-50 rounded-lg">
              <svg className="w-6 h-6 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
          </div>
          <div className="text-2xl font-bold text-gray-900">{users.length}</div>
        </div>

        {/* Total Active Card */}
        <div className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-gray-500 text-sm font-medium">Total Active</h3>
            <div className="p-2 bg-green-50 rounded-lg">
              <svg className="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          </div>
          <div className="text-2xl font-bold text-gray-900">{totalActive}</div>
        </div>

        {/* Total Applications Card */}
        <div className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow cursor-pointer" onClick={() => setShowDemos(true)}>
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-gray-500 text-sm font-medium">Total Applications</h3>
            <div className="p-2 bg-blue-50 rounded-lg">
              <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
            </div>
          </div>
          <div className="text-2xl font-bold text-gray-900">
            {countApplications} 
            <span className="text-sm font-normal text-gray-500 ml-2">/ {countTotalApplications} Total</span>
          </div>
        </div>

        {/* Total Approved Card */}
        <div className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-gray-500 text-sm font-medium">Total Approved</h3>
            <div className="p-2 bg-green-50 rounded-lg">
              <svg className="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
          <div className="flex items-baseline">
            <div className="text-2xl font-bold text-gray-900">{countApproved}</div>
            <span className="text-sm text-gray-500 ml-2">/ {countTotalApproved} Total</span>
            {countApproved > 0 && (
              <span className="text-xs font-medium text-green-600 ml-2">
                ({((countApproved / countTotalApproved) * 100).toFixed(1)}%)
              </span>
            )}
          </div>
        </div>

        {/* Total Declined Card */}
        <div className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-gray-500 text-sm font-medium">Total Declined</h3>
            <div className="p-2 bg-red-50 rounded-lg">
              <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
          </div>
          <div className="text-2xl font-bold text-gray-900">{countDeclined}</div>
        </div>
      </div>

      <div>
        <div className='admindashboard__search-lookup'>
          <input type='text' placeholder='Search...' className='input' value={query} onChange={(e) => setQuery(e.target.value)} onKeyUp={(e) => handleKeyUp(e)} />

          <div className='admindashboard__search-lookup-btn'>
            <button className='btn' onClick={() => handleSearch()}>Search</button>
          </div>
        </div>
      </div>

      {loaded === false && (
        <Spinner />
      )}

      {loaded && users.length === 0 && (
        <div className='center mt-20'><strong>Nothing to see here...</strong></div>
      )}

      {loaded && users.length > 0 && (
        <div>
          {users.map((item, index) => (
            <div key={index} className='buyers__user'>
              <div>
                <div className='relative'>
                  <span className='admindashboard__demo-card-submenu-icon' onClick={() => {
                    if (selectedUserId != null && selectedUserId === item.registered_user_id) {
                      setShowSubMenu(!showSubMenu);
                    }

                    else {
                      setShowSubMenu(true);
                      setSelectedUserId(item.registered_user_id);
                    }
                  }}>
                    <FaEllipsisV />
                  </span>

                  {showSubMenu == true && selectedUserId == item.registered_user_id && (
                    <FadeIn delay={100} duration={100}>
                      <div className='dashboard__submenu'>
                        <div className='dashboard__submenu-item' onClick={() => {
                          setSelectedUserId(item.registered_user_id);
                          setShowSetTestConfirm(true);
                        }}>Set as test account</div>

                        <div className='dashboard__submenu-item' onClick={() => {
                          setSelectedUserId(item.registered_user_id); setShowDeleteConfirm(true);

                        }}>Delete account</div>
                      </div>
                    </FadeIn>
                  )}
                </div>
              </div>

              <div className='companylookup__company-status-bar'>
                <div className="flex items-center gap-4">
                  {item.profile_image ? (
                    <img 
                     src={baseImageUrl + 'profileimages/' + item.profile_image}

                      alt={`${item.first_name}'s profile`}
                      className="w-12 h-12 rounded-full object-cover border-2 border-purple-100"
                    />
                  ) : (
                    <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 border-2 border-purple-100">
                      {item.first_name?.charAt(0)}{item.last_name?.charAt(0)}
                    </div>
                  )}
                </div>

                <div className='companylookup__company-status-bar-item success'>
                  <span>New</span> <span><FaRegCheckCircle /></span>
                </div>

                <div className={`companylookup__company-status-bar-item ${item.profile_reviewed_by_admin ? 'success' : ''}`}>
                  <span>Profile reviewed</span>

                  {item.profile_reviewed_by_admin && (
                    <span><FaRegCheckCircle /></span>
                  )}
                </div>

                <div className={`companylookup__company-status-bar-item ${item.is_verified ? 'success' : ''}`}>
                  <span>Is Verified</span>

                  {item.is_verified && (
                    <span><FaRegCheckCircle /></span>
                  )}
                </div>

                <div className={`companylookup__company-status-bar-item ${item.work_email_verified ? 'success' : ''}`}>
                  <span>Work email verified</span>

                  {item.work_email_verified && (
                    <span><FaRegCheckCircle /></span>
                  )}
                </div>

                <div className={`companylookup__company-status-bar-item ${item.demos_approved != '0' ? 'success' : ''}`}>
                  <span>First demo booked</span>

                  {item.demos_approved != '0' && (
                    <span><FaRegCheckCircle /></span>
                  )}
                </div>

                <div className={`companylookup__company-status-bar-item ${item.is_on_drip == true ? 'success' : ''}`}>
                  <span>On drip <FaEyeDropper /></span>

                  {item.is_on_drip == true && (
                    <span><FaRegCheckCircle /></span>
                  )}
                </div>
              </div>

              <div className='flex'>
                {/* <div className='buyers__status-items'>
                  <div class="buyers__status"><h3>"Next Steps" email to seller</h3><p class="buyers__status-copy">Send "Next steps" email to seller after they have received 2 demo applications.</p><div class="mt-10"><button class="btn">Send email</button><button class="btn ml-10">Already sent</button><button class="btn ml-10">Skip send</button></div></div>
                </div> */}

                <div className='buyers__table-wrapper'>
                  <table className='table admindashboard__table'>
                    <tr>
                      <td>Joined on</td>
                      <td>
                        <div className='' style={{ fontSize: '16px', fontWeight: 'bold' }}>
                          <div style={{ fontSize: '12px' }}>{new Date(item.date_created).toLocaleDateString()}</div>

                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>Roles</td>
                      <td>
                        <div>
                          {item.is_buyer && (
                            <span className='admindashboard__role-tag--buyer'>Buyer</span>
                          )}

                          {item.is_seller && (
                            <span className='admindashboard__role-tag--seller'>Seller</span>
                          )}

                          {item.is_event_host && (
                            <span className='admindashboard__role-tag--host'>Host</span>
                          )}

                          {item.is_event_attendee && (
                            <span className='admindashboard__role-tag--attendee'>Events</span>
                          )}

                          {item.is_test_account && (
                            <span className='admindashboard__red-flag'>Test</span>
                          )}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Name</td>
                      <td><div>
                        {item.first_name} {item.last_name} - #{item.registered_user_id}
                      </div></td>
                    </tr>

                    <tr>
                      <td>Email</td>
                      <td>{item.email}</td>
                    </tr>

                    <tr>
                      <td>Work Email</td>
                      <td>
                        <div>
                          {item.work_email && item.work_email.length > 0 ? (
                            <span className='admindashboard__green-flag'>{item.work_email}</span>
                          ) : (
                            <span className='admindashboard__red-flag'>Not set</span>
                          )}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>Company</td>

                      <td>
                        <div className='flex' style={{ alignItems: 'center' }}>
                          <div className='buyerdashboard__recommendation-logo'>
                            <img src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' + item.company_logo} />
                          </div>

                        </div>

                        <div>
                          {item.company_id} - {item.company_name}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>Timezone</td>
                      <td>
                        <div>
                          {item.timezone}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>Country</td>

                      <td>
                        <div>
                          {item.country_name && item.country_name.length > 0 ? item.country_name : <i>Not set</i>}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>Job title</td>
                      <td>
                        <div>
                          {item.job_title}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>Company size</td>
                      <td>
                        <div>
                          {item.company_size}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>No of applications</td>
                      <td>
                        <div>
                          {item.application_count}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>No approved</td>
                      <td>
                        {item.approved_count}

                      </td>
                    </tr>

                    <tr>
                      <td>No declined</td>
                      <td>
                        {item.declined_count}

                      </td>
                    </tr>

                    <tr>
                      <td>LinkedIn</td>
                      <td>
                        {item.linkedin_url && (
                          <div>
                            <strong>LI: </strong>

                            {item.linkedin_url && item.linkedin_url.length > 0 && (
                              <span className='ml-10'><a href={item.linkedin_url}>LinkedIn</a></span>
                            )}

                            {(item.linkedin_url === null || item.linkedin_url.length === 0) && (
                              <span className='ml-10'><i>Not set</i></span>
                            )}
                          </div>
                        )}
                      </td>
                    </tr>

                    <tr>
                      <td>Source</td>

                      <td>
                        <div>
                          {item.signup_source}
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>


              {/* <td>
                  <div>

                    <div style={{fontSize: '20px'}} className='bold'>
                      {item.email} {item.is_verified && (<span><FaCheckCircle style={{color: 'mediumseagreen'}} /></span>)}

                      {item.is_verified === false && (
                        <span><FaTimesCircle style={{color: 'red'}} /></span>
                      )}
                    </div>
                  </div>
                 


                  {item.work_email && (
                    <div><strong>Work: </strong> <span className='admindashboard__green-flag'>{item.work_email}</span></div>
                  )}

                  {item.work_email === null && (
                    <div><strong>Work:</strong> <span className='admindashboard__red-flag'>Not found</span></div>
                  )}


                </td> */}
            </div>
          ))}
        </div>
      )}

      {showDeleteConfirm && (
        <>
          <div className='overlay'></div>
          <div className='modal'>
            <div className='modal__close' onClick={() => setShowDeleteConfirm(false)}>
              <FaTimes />
            </div>

            <h2 className='modal__h2'>
              Delete user?
            </h2>

            <p className='mt-10 mb-10'>
              This user will be completely removed from the site.
            </p>

            <div className='mt-20 center'>
              <button className='btn' onClick={() => handleConfirmDelete()}>Confirm</button>
            </div>
          </div>
        </>
      )}

      {showSetTestConfirm && (
        <>
          <div className='overlay'></div>
          <div className='modal'>
            <div className='modal__close' onClick={() => setShowSetTestConfirm(false)}>
              <FaTimes />
            </div>

            <h2 className='modal__h2'>
              Set as test account
            </h2>

            <div className='mt-20 center'>
              <button className='btn' onClick={() => handleSetTest()}>Set as test account</button>
            </div>
          </div>
        </>
      )}

      {showDemos && (
        <>
          <div className='overlay'></div>
          <div className='modal' style={{ width: '80%', marginLeft: '-40%' }}>
            <div className='modal__close' onClick={() => setShowDemos(false)}>
              <FaTimes />
            </div>

            <h2 className='modal__h2'>Latest buyer demos</h2>
            <div className='mt-10'>
              <table className='table admindashboard__table'>
                {latestDemos.filter(x => new Date(x.date_created).getMonth() == new Date().getMonth() && new Date(x.date_created).getFullYear() == new Date().getFullYear()).map((item, index) => (
                  <>
                    <tr className=''>
                      <td>
                        #{index} - {new Date(item.date_created).toLocaleDateString()}
                      </td>

                      <td>
                        <div className='companylookup__demo-company'>
                          <div className=''>
                            <img src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' + item.buyer_logo} style={{ maxHeight: '34px' }} />
                          </div>
                          <div>{item.buyer_company_name}</div>

                          <div>
                            {item.buyer_status == 'Approved' && (
                              <span className='admindashboard__green-flag'>{item.buyer_status}</span>
                            )}

                            {item.buyer_status == 'Rescheduled' && (
                              <span className='admindashboard__blue-flag'>{item.buyer_status}</span>
                            )}

                            {item.buyer_status == 'Declined' && (
                              <span className='admindashboard__red-flag'>{item.buyer_status}</span>
                            )}
                          </div>
                        </div>
                      </td>

                      <td>
                        <div className='companylookup__demo-company'>
                          <div className=''>
                            <img src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' + item.seller_logo} style={{ maxHeight: '34px' }} />
                          </div>
                          <div>{item.seller_company_name}</div>

                          <div>
                            {item.seller_status == 'Approved' && (
                              <span className='admindashboard__green-flag'>{item.seller_status}</span>
                            )}

                            {item.seller_status == 'Pending' && (
                              <span className='admindashboard__yellow-flag'>
                                {item.seller_status}
                              </span>
                            )}

                            {item.seller_status == 'Declined' && (
                              <span className='admindashboard__red-flag'>
                                {item.seller_status}
                              </span>
                            )}

                            {item.seller_status == 'Rescheduled' && (
                              <span className='admindashboard__blue-flag'>
                                {item.seller_status}
                              </span>
                            )}
                          </div>
                        </div>
                      </td>

                      <td>
                        <div>
                          {item.payment_type}
                        </div>
                      </td>

                      <td>
                        <div>
                          {item.demo_status_id == 1 && (
                            <span className='admindashboard__yellow-flag'>{item.demo_status}</span>
                          )}

                          {item.demo_status_id == 4 && (
                            <span className='admindashboard__green-flag'>{item.demo_status}</span>
                          )}

                          {item.demo_status_id == 3 && (
                            <span className='admindashboard__red-flag'>{item.demo_status}</span>
                          )}
                        </div>
                      </td>
                    </tr>
                  </>
                ))}
              </table>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Buyers;